module.exports = __webpack_public_path__ + "static/media/logo_pepites.f93bde32.png";